import { render, staticRenderFns } from "./infomation.vue?vue&type=template&id=c5c5ae3e&scoped=true&"
import script from "./infomation.vue?vue&type=script&lang=js&"
export * from "./infomation.vue?vue&type=script&lang=js&"
import style0 from "./infomation.vue?vue&type=style&index=0&id=c5c5ae3e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c5ae3e",
  null
  
)

export default component.exports